<template>
  <b-card header="Assign user">
    <!-- <div id="cover" style="position: fixed; height: 100%; width: 100%; top:0; left: 0; background: rgba(255, 255, 255, 0.8); z-index:9999;">
      <div style="color:white;position: absolute; margin: auto; top: 0; right: 0; bottom: 0; left: 0; width: 200px; height: 30px; border-radius: 3px;">
      <img class="navbar-brand-full" src="/static/img/preload.gif">
      </div>
    </div> -->
    <div>
      <b-form-group>
        <b-input-group>
          <b-input-group-prepend><b-input-group-text>Username</b-input-group-text></b-input-group-prepend>
          <input type="text" v-model="formData.username" placeholder="Email or Phone" class="form-control"/>
          <b-input-group-append><b-input-group-text><i class="nav-icon icon-user"></i></b-input-group-text></b-input-group-append>
        </b-input-group>
      </b-form-group>

      <div class="form-group form-actions">
        <b-button @click="submitData" type="button" size="sm" variant="primary">Search</b-button>
      </div>
    </div>

    <b-table responsive="sm" :items="users" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter">
      <template slot="avatar" slot-scope="data">
          <img class="img-avatar" :src="data.item.avatar" :alt="data.item.email" style="margin:10px; height:35px;" v-if="data.item.avatar">
          <img src="https://static.wixstatic.com/media/5b2a92_dc7da9aba3554b5eb93fdcc6a84545d9~mv2.png/v1/fill/w_63,h_64,al_c,usm_0.66_1.00_0.01/5b2a92_dc7da9aba3554b5eb93fdcc6a84545d9~mv2.png" border="0" style="float:left; height:35px; margin:10px;" v-if="(data.item.avatar == '' || data.item.avatar == null)">
          <span class="avatar-status badge-success" style="position: absolute;left: 5px;top: 10px;"></span>
      </template>
      <template slot="user" slot-scope="data">

        <small class="text-muted ng-binding">
          <strong><i class="icon-user"></i>: {{data.item.name}}</strong><br/>
          <strong><i class="icon-envelope"></i>:</strong> <a :href="mailto(data.item.email)">{{data.item.email}}</a><br/>
          <strong><i class="icon-phone"></i>:</strong> {{data.item.phone}} <a :href="whatsapp(data.item.phone)" :target="data.item.phone"><i class="fa fa-whatsapp"></i></a>
        </small>
      </template>

      <template slot="hausType" slot-scope="data">
        <small class="text-muted ng-binding">
          {{hausTypes[data.item.hausType]}}
        </small>
      </template>

      <template slot="action" slot-scope="data">
        <b-button type="button" variant="danger"  @click.stop="showModal(moralRevokeId(data.item.id), $event.target)" style="float:right; margin-right:5px;">
          <i class="fa fa-trash"></i>
          Revoke
        </b-button>
        <b-button type="button" variant="primary"  @click.stop="showModal(modalManagerId(data.item.id), $event.target)" style="float:right; margin-right:5px;">
          <i class="icon-people"></i>
          Manager
        </b-button>

        <b-button type="button" variant="primary"  @click.stop="showModal(modalOwnerId(data.item.id), $event.target)" style="float:right; margin-right:5px;">
          <i class="icon-user"></i>
          Owner
        </b-button>
      </template>
    </b-table>

    <div v-for="userLoop in users" :key="userLoop.id">
      <b-modal :id="moralRevokeId(userLoop.id)" @ok="handleOk(userLoop.username, 'revoke', modalId(userLoop.id), $event.target)" centered>
        <div class="modal-window">
          <div class="alert alert-danger">
            <ul class="fa-ul" style="margin-bottom: 0px;">
              <li>
                <i class="fa fa-info-circle fa-li"></i>
                <p>Are you sure you want to REVOKE HAUS Access from the selected user:<br/> <strong>{{ userLoop.name }}</strong>?</p>
              </li>
            </ul>
          </div>
        </div>
      </b-modal>

      <b-modal :id="modalManagerId(userLoop.id)" @ok="handleOk(userLoop.username, 'manager', modalId(userLoop.id), $event.target)" centered>
        <div class="modal-window">
          <div class="alert alert-warning">
            <ul class="fa-ul" style="margin-bottom: 0px;">
              <li>
                <i class="fa fa-info-circle fa-li"></i>
                <p>Are you sure you want to set HAUS access as Manager for:<br/> <strong>{{ userLoop.name }}</strong>?</p>
              </li>
            </ul>
          </div>
        </div>
      </b-modal>

      <b-modal :id="modalOwnerId(userLoop.id)" @ok="handleOk(userLoop.username, 'owner', modalId(userLoop.id), $event.target)" centered>
        <div class="modal-window">
          <div class="alert alert-success">
            <ul class="fa-ul" style="margin-bottom: 0px;">
              <li>
                <i class="fa fa-info-circle fa-li"></i>
                <p>Are you sure you want to set HAUS access as Owner for:<br/> <strong>{{ userLoop.name }}</strong>?</p>
              </li>
            </ul>
          </div>
        </div>
      </b-modal>
    </div>
  </b-card>
</template>

<script>
let qs = require('qs')
const constants = require('../shared/constants')
const BASE = constants.NEWPORT_CONST.API_URL
const API_SEARCH = BASE + '/api/users/detail'
const API_SET_HAUSTYPE = BASE + '/api/users/setHausType'

function postdata (url, data) {
  return fetch(url, {
    body: qs.stringify(data),
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
      'Authorization': localStorage.getItem('token')
    },
    method: 'POST'
  })
    .then(res => res.json())
}

async function updateStatus (username, hausType) {
  let parameters = {
    client_id: constants.NEWPORT_CONST.CLIENT_ID,
    client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
    access_token: localStorage.getItem('token'),
    username: username,
    hausType: hausType
  }
  let res = await postdata(API_SET_HAUSTYPE, parameters)
  return res.user
}

export default {
  name: 'assign-haus-type',
  data () {
    return {
      modalShowEmpty: false,
      users: [],
      formData: {
        client_id: constants.NEWPORT_CONST.CLIENT_ID,
        client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
        access_token: localStorage.getItem('token'),
        username: '',
        hausType: ''
      },
      hausTypes: ['Internal', 'Owner', 'Manager'],
      fields: {
        avatar: {
          label: 'Avatar'
        },
        user: {
          label: 'User'
        },
        // email: {
        //   label: 'Email'
        // },
        // phone: {
        //   label: 'Phone'
        // },
        hausType: {
          label: 'Haus Type'
        },
        action: {
          label: 'Action'
        }
      },
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      filter: null
    }
  },
  methods: {
    submitData (evt) {
      evt.preventDefault()
      if (localStorage.getItem('token') && localStorage.getItem('ouht') == 0) {
        if (this.formData.username.length > 5) {
          this.users = [] // reset list
          postdata(API_SEARCH, this.formData)
            .then(data => {
              this.users.push(data.user)
              console.log(data)
            })
            .catch(error => {
              console.error(error)
            })
        } else {
          alert('Please put username in')
        }
      }
    },
    showModal (id, button) {
      this.$root.$emit('bv::show::modal', id, button)
    },
    moralRevokeId (i) {
      return 'modalrevoke' + i
    },
    modalOwnerId (i) {
      return 'modalowner' + i
    },
    modalManagerId (i) {
      return 'modalmanager' + i
    },
    modalId (i) {
      return 'modal' + i
    },
    handleOk (id, action, modalId, button) {
      if (action == 'revoke') {
        updateStatus(id, -1).then(response => {
          this.refreshList()
          console.log(response)
        }).catch(error => {
          console.error(error)
        })
      } else if (action == 'manager') {
        updateStatus(id, 2).then(response => {
          this.refreshList()
          console.log(response)
        }).catch(error => {
          console.error(error)
        })
      } else if (action == 'owner') {
        updateStatus(id, 1).then(response => {
          this.refreshList()
          console.log(response)
        }).catch(error => {
          console.error(error)
        })
      }
      this.$root.$emit('bv::hide::modal', modalId, button)
      // refresh List
      // window.open(
      //   this.whatsapp(id),
      //   id // <- This is what makes it open in a new window.
      // );
    },
    refreshList () {
      this.users = []
      postdata(API_SEARCH, this.formData)
        .then(data => {
          this.users.push(data.user)
          console.log(data)
        })
        .catch(error => {
          console.error(error)
        })
    },
    mailto (email) {
      return 'mailto:' + email
    },
    whatsapp (phone) {
      let phoneNoPlus = phone.slice(1)
      return 'https://api.whatsapp.com/send?phone=' + phoneNoPlus
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/views/base/intern/AssignHausType.vue